import { z } from 'zod/v3';

// Role DTOs
export const RoleDTOSchema = z.object({
  id: z.string(),
  name: z.string(),
  userRoles: z.array(z.string())
}).strict();

export const RoleListDTOSchema = z.object({
  id: z.string(),
  name: z.string()
}).strict();

export const CreateRoleDTOSchema = z.object({
  name: z.string(),
  userRoles: z.array(z.string())
}).strict();

export const UpdateRoleDTOSchema = z.object({
  id: z.string(),
  name: z.string().optional(),
  userRoles: z.array(z.string()).optional()
}).strict();

export type RoleDTO = z.infer<typeof RoleDTOSchema>;
export type RoleListDTO = z.infer<typeof RoleListDTOSchema>;
export type CreateRoleDTO = z.infer<typeof CreateRoleDTOSchema>;
export type UpdateRoleDTO = z.infer<typeof UpdateRoleDTOSchema>;
